(function () {
  function initBandages(rootElement) {
    const bandageItemsElements = rootElement.querySelectorAll('.bandages__bandage-items');
    const bandageTextItems = ['Naturally high caffeine', 'Turmeric', 'Black pepper', 'Ginger', 'Low acid', 'Cinnamon'];

    bandageItemsElements.forEach((bandageItemsElement) => {
      const innerHTML = getTextItemsAsHTML(shuffle(bandageTextItems));
      bandageItemsElement.insertAdjacentHTML('beforeend', innerHTML);
    });

    function getTextItemsAsHTML(items = []) {
      return items
        .map(
          (textItem) => `
            <img class="bandages__bandage-image" src="${window.kcupImageUrl}" alt="kcup-icon">
            <p class="bandages__bandage-text">${textItem}</p>
          `
        )
        .join('');
    }

    function shuffle(array = []) {
      const newArray = array.slice();
      let currentIndex = newArray.length;
      while (currentIndex != 0) {
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [newArray[currentIndex], newArray[randomIndex]] = [newArray[randomIndex], newArray[currentIndex]];
      }
      return newArray;
    }
  }

  window.initBandages = initBandages;
})();
